import { render, staticRenderFns } from "./template-list.vue?vue&type=template&id=606b7a3d&scoped=true&"
import script from "./template-list.vue?vue&type=script&lang=js&"
export * from "./template-list.vue?vue&type=script&lang=js&"
import style0 from "./template-list.vue?vue&type=style&index=0&id=606b7a3d&lang=scss&scoped=true&"
import style1 from "./template-list.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "606b7a3d",
  null
  
)

export default component.exports